
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/[postShortId]",
      function () {
        return require("private-next-pages/forum/[postShortId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forum/[postShortId]"])
      });
    }
  